import { c as _c } from "react/compiler-runtime";
import { useFormatter, useTranslations } from 'next-intl';
import { useState } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { ChartBarLineIcon, HelpCircleIconSolid } from '@/components/ui/icon/glyphs';
import { ComparisonCards } from './comparison-cards';
import { DemocracyScoreRing } from './democracy-score-ring';
import { ResolutionIntegrityHelpModal } from './resolution-integrity-help-modal';
import type { ResolutionIntegrity } from './resolution-integrity-types';
import { TradingActivityModal } from './trading-activity-modal';
import { TradingInformationTable } from './trading-information-table';
export function ResolutionIntegrityView(t0) {
  const $ = _c(58);
  const {
    data
  } = t0;
  const t = useTranslations("market.resolutionIntegrity");
  const intl = useFormatter();
  const [helpOpen, setHelpOpen] = useState(false);
  const [activityOpen, setActivityOpen] = useState(false);
  let t1;
  if ($[0] !== t) {
    t1 = t("regionLabel");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("title");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <h3 className="text-body-lg font-semibold text-foreground-primary">{t2}</h3>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("activityOpen");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setActivityOpen(true);
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4) {
    t6 = <AnimatedButton type="button" variant="tertiary" size="xs" prefix={ChartBarLineIcon} aria-label={t4} onClick={t5} />;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("helpOpen");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setHelpOpen(true);
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7) {
    t9 = <AnimatedButton type="button" variant="tertiary" size="xs" prefix={HelpCircleIconSolid} aria-label={t7} onClick={t8} />;
    $[14] = t7;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t6 || $[17] !== t9) {
    t10 = <div className="flex items-center gap-1">{t6}{t9}</div>;
    $[16] = t6;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t3) {
    t11 = <div className="flex items-center justify-between gap-2">{t3}{t10}</div>;
    $[19] = t10;
    $[20] = t3;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== data.score) {
    t12 = <DemocracyScoreRing score={data.score} />;
    $[22] = data.score;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== data.comparisons) {
    t13 = <ComparisonCards comparisons={data.comparisons} />;
    $[24] = data.comparisons;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t12 || $[27] !== t13) {
    t14 = <div className="flex min-w-0 flex-col gap-4 sm:flex-row sm:items-center">{t12}{t13}</div>;
    $[26] = t12;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== data.comparisons || $[30] !== data.finalWindowSeconds || $[31] !== data.outcomes || $[32] !== data.pubkey || $[33] !== data.winningOutcomeIndex) {
    t15 = <TradingInformationTable pubkey={data.pubkey} outcomes={data.outcomes} winningOutcomeIndex={data.winningOutcomeIndex} comparisons={data.comparisons} finalWindowSeconds={data.finalWindowSeconds} />;
    $[29] = data.comparisons;
    $[30] = data.finalWindowSeconds;
    $[31] = data.outcomes;
    $[32] = data.pubkey;
    $[33] = data.winningOutcomeIndex;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== data.resolvedAt || $[36] !== intl || $[37] !== t) {
    t16 = t("tableCaption", {
      resolvedAt: intl.dateTime(new Date(data.resolvedAt), {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "UTC",
        timeZoneName: "short"
      })
    });
    $[35] = data.resolvedAt;
    $[36] = intl;
    $[37] = t;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t) {
    t17 = t("disclaimer");
    $[39] = t;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t16 || $[42] !== t17) {
    t18 = <p className="text-caption text-foreground-tertiary">{t16}{" "}{t17}</p>;
    $[41] = t16;
    $[42] = t17;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== helpOpen) {
    t19 = <ResolutionIntegrityHelpModal open={helpOpen} onOpenChange={setHelpOpen} />;
    $[44] = helpOpen;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== activityOpen || $[47] !== data.activity || $[48] !== data.outcomes) {
    t20 = <TradingActivityModal open={activityOpen} onOpenChange={setActivityOpen} activity={data.activity} outcomes={data.outcomes} />;
    $[46] = activityOpen;
    $[47] = data.activity;
    $[48] = data.outcomes;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== t1 || $[51] !== t11 || $[52] !== t14 || $[53] !== t15 || $[54] !== t18 || $[55] !== t19 || $[56] !== t20) {
    t21 = <section aria-label={t1} data-testid="resolution-integrity" className="flex min-w-0 flex-col gap-4 border-t border-border-secondary pt-4">{t11}{t14}{t15}{t18}{t19}{t20}</section>;
    $[50] = t1;
    $[51] = t11;
    $[52] = t14;
    $[53] = t15;
    $[54] = t18;
    $[55] = t19;
    $[56] = t20;
    $[57] = t21;
  } else {
    t21 = $[57];
  }
  return t21;
}